module.exports = __webpack_public_path__ + "img/darceo_logo_hand.864edae9.png";